module.exports = __webpack_public_path__ + "static/media/logo_credicomin.2731161f.svg";